'use strict';

var clientSideValidation = require('../components/clientSideValidation');
var formValidation = require('../components/formValidation');
var addNewSchool = require('../addNewSchl');
var sessionTimeoutModal = require('../components/sessionTimeoutModal');

var CREATE_ACCOUNT_MODAL_CONTENT = '#createAccountModal .modal-content';
var ACTIVATION_MODAL_CONTENT = '#activationModal .modal-content';
var KEYUP_FOCUSOUT = 'keyup focusout';
var MODAL_CONTENT = '.modal-content';
var NEXT_STEP_VISIBLE = '.next-step:visible';
var MODAL_SHOW = '.modal.show';
var VALIDATE_CONFIRM_PASSWORD = '.validateconfirmpassword';
var ACTIVATION_TOKEN = 'activationToken';
var RESET_PASSWORD_TOKEN = 'resetPasswordToken';
var BACK_STEP = '.back-step';
var MULTIPLESTEPS = '.multiplesteps';
var CREATE_ACCOUNT_MODAL_ID = '#createAccountModal';
var SIGN_IN_MODAL_ID = '#signInModal';
var FORM_LOGIN_SELECTOR = 'form.login';
var CREATE_ACCOUNT_SUBMIT_FORM_ID = '#createAccountSubmitForm';
var RESET_PASSWORD_SEND_EMAIL_CTA_ID = '#resetPasswordSendEmailCta';
var MODAL_BODY_SELECTOR = '.modal-body';
var UPDATE_PRED_MODAL_GO_TO_PROFILE_ID = '#updatePredModalGoToProfile';
var DISABLED_ATTR = 'disabled';
var SIGNIN_MODAL_OPEN = 'signinModal:open';
var ACCOUNT_PAGE_SELECTOR = '.account-page';

/**
 * Get cookie value by cookie name from browser
 * @param {string} cookieName - name of the cookie
 * @returns {string} cookie value of the found cookie name
 */
function getCookie(cookieName) {
    var name = cookieName + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
        var cookieItem = cookieArray[i];
        while (cookieItem.charAt(0) === ' ') {
            cookieItem = cookieItem.substring(1);
        }
        if (cookieItem.indexOf(name) === 0) {
            return cookieItem.substring(name.length, cookieItem.length);
        }
    }
    return '';
}

function getHomeUrl() {
    return window.location.origin + $('.logo-home').attr('href');
}

function populateCurrentYear() {
    $('.print-current-year').html(new Date().getFullYear());
}

function changeDialog(closeDialogID, openDialogID) {
    if (closeDialogID) {
        closeDialogID.modal("hide");
    }
    openDialogID.modal({ keyboard: false, backdrop: 'static' });
    $(openDialogID).on('shown.bs.modal', function (e) {
        $('body').addClass('modal-open');
    });
}

function loadCreateAccountShowData(url, noNeedOfNewModal) {
    const loader = $(CREATE_ACCOUNT_MODAL_CONTENT);
    loader.spinner().start();
    $.ajax({
        url: url,
        type: 'get',
        success: function (data) {
            $(CREATE_ACCOUNT_MODAL_CONTENT).empty().html(data);
            populateCurrentYear();
            clientSideValidation.addValidation();

            const submitCta = $('#createAccountShowSubmitCta');

            $('input[name="doYouTeachInSchool"]').on('change', function(e) {
                const createAccountNonEduMsg = $('#createAccountNonEduMsg');

                if ($(e.target).attr('id') === 'teachInSchoolYes') {
                    $('.createaccount-nextbtn-visibility').removeClass('d-none').addClass('d-flex');
                    $(submitCta).removeAttr(DISABLED_ATTR);
                    $(createAccountNonEduMsg).addClass('d-none');
                } else {
                    $(submitCta).attr(DISABLED_ATTR, DISABLED_ATTR);
                    $(createAccountNonEduMsg).removeClass('d-none');
                    $('.createaccount-nextbtn-visibility').addClass('d-none').removeClass('d-flex');
                }
            });

            $(submitCta).on('click', function(e) {
                const createAccountEduShowUrl = $(this).data('href');
                showCreateAccountEduForm(e, createAccountEduShowUrl, loader);
            });

            if (noNeedOfNewModal) {
                $('#teachInSchoolYes').trigger('click');
            }
            loader.spinner().stop();
        },
        error: function() {
            loader.spinner().stop();
        }
    });
}

function showCreateAccountEduForm(e, url, loader) {
    e.preventDefault();
    loader.spinner().start();
    $.ajax({
        url: url,
        type: 'get',
        success: function (data) {
            $(CREATE_ACCOUNT_MODAL_CONTENT).empty().html(data);
            clientSideValidation.addValidation();
            loader.spinner().stop();

            var form = CREATE_ACCOUNT_MODAL_ID, // Instead of form send modal id bcoz cta is outside of form
                submitCta = '#addSchoolBtn';

            $(form).find(".step-1").on(KEYUP_FOCUSOUT, "input", function() {
                clientSideValidation.enableDisbaleButton(form, submitCta);
            });

            $(form).on(KEYUP_FOCUSOUT, "input.femail", function() {
                var $elementForm = $(this).closest("form");
                if (($elementForm.find('.validateconfirmemail').val() !== "")) {
                    $elementForm.find('.validateconfirmemail').trigger("keyup", {which: 50});
                }
                clientSideValidation.enableDisbaleButton(form, submitCta);
            });

            $(form).on(KEYUP_FOCUSOUT, "input.fpassword", function() {
                var $elementForm = $(this).closest("form");
                if (($elementForm.find(VALIDATE_CONFIRM_PASSWORD).val() !== "")) {
                    $elementForm.find(VALIDATE_CONFIRM_PASSWORD).trigger("keyup", {which: 50});
                }
                clientSideValidation.enableDisbaleButton(form, submitCta);
            });
        },
        error: function() {
            loader.spinner().stop();
        }
    });
}

function getCreateAccountFormData() {
    const grades = [];
    const selectedGrades = $('.account-grades-list input:checked');
    for (let i = 0; i < selectedGrades.length; i++) {
        if ($(selectedGrades[i]).data('isplusgrade')) {
            var gradeLevel = parseInt(selectedGrades[i].id);
            while(gradeLevel <= 12) {
                grades.push(gradeLevel);
                gradeLevel++;
            }
        } else {
            grades.push(selectedGrades[i].id);
        }
    }
    var schoolId = $('.addnewschool_selectedSchool_id').val();
    return $(CREATE_ACCOUNT_SUBMIT_FORM_ID).serialize() + '&grades='+ grades.join(',') + '&schoolId='+schoolId; // NOSONAR
}

function passwordResetFormSubmit(e, form, loader) {
    e.preventDefault();
    loader.spinner().start();
    const url = $(form).attr('action');
    $.ajax({
        url: url,
        type: 'post',
        data: form.serialize(),
        success: function (data) {
            $('#passwordResetModal .modal-content').empty().html(data);
            window.location.href = getHomeUrl();
        },
        error: function() {
            window.location.href = getHomeUrl();
        }
    });
}

module.exports = {
    login: function () {
        $(document).on('submit', FORM_LOGIN_SELECTOR, function (e) {
            var form = $(this);
            var loader = form.parents(MODAL_CONTENT);
            e.preventDefault();
            var url = form.attr('action');
            loader.spinner().start();
            $(FORM_LOGIN_SELECTOR).trigger('login:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    loader.spinner().stop();
                    if (!data.success) {
                        clientSideValidation.addValidation();
                        if (data.status === 'ERROR_NONEDU_LOGIN') {
                            $('.login-noneduattempt-section').removeClass('d-none');
                            $('.login-section').addClass('d-none');
                        } else {
                            $(FORM_LOGIN_SELECTOR).trigger('login:error', data);
                            // show error msg
                            $('.login-error').html(data.error).removeClass('d-none');
                        }
                    } else {
                        $(FORM_LOGIN_SELECTOR).trigger('login:success', data);
                        if (window.location.href.indexOf(ACTIVATION_TOKEN) > 1) {
                            window.location.href = getHomeUrl();
                        } else {
                            location.reload();
                        }
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $(FORM_LOGIN_SELECTOR).trigger('login:error', data);
                        loader.spinner().stop();
                    }
                }
            });
            return false;
        });
    },

    resetPassword: function () {
        $(document).on('submit', '.reset-password-form', function (e) {
            e.preventDefault();
            var form = $(this);
            var url = form.attr('action');
            var loader = form.parents(MODAL_CONTENT);
            loader.spinner().start();

            $.ajax({
                url: url,
                type: 'post',
                data: form.serialize(),
                success: function (data) {
                    loader.spinner().stop();
                    $('#requestPasswordResetModal .modal-content').empty().html(data);
                },
                error: function () {
                    loader.spinner().stop();
                }
            });
            return false;
        });
    },

    clearResetForm: function () {
        $('#login .modal').on('hidden.bs.modal', function () {
            $('#reset-password-email').val('');
            $('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
        });
    },

    roleChangeHandle: function() {
        $(document).on('change', '#userRole', function() {
            if ($(this).val() === 'SBS') {
                $('.subrole-container').removeClass('d-none');
            } else {
                $('.subrole-container').addClass('d-none');
                $('.userSubRole option').removeAttr('selected');
            }
        });

        $(document).on('change', '#userRole, #userSubRole, .account-grades-list input', function() {
            var form = CREATE_ACCOUNT_MODAL_ID, // Instead of form send modal id bcoz cta is outside of form
                submitCta = $(form).find(NEXT_STEP_VISIBLE);

            if ($(ACCOUNT_PAGE_SELECTOR).length) {
                form = '#dwfrm_profile_changeschoolrole';
                submitCta = $(form).find('.btn-accountform-submit');
            }
            clientSideValidation.enableDisbaleButton(form, submitCta);
        });
    },

    selectUnselectAllGrades: function() {
        $('body').on('click', '#selectAllGrades, .no-preference, .account-grades-list .custom-checkbox:not(.no-preference)', function() {
            var form = CREATE_ACCOUNT_MODAL_ID, // Instead of form send modal id bcoz cta is outside of form
                submitCta = $(form).find(NEXT_STEP_VISIBLE);

            const $this = $(this),
                $allGrades = $('.account-grades-list input[type="checkbox"]:not(#NP)'),
                $nopreference = $('.no-preference input');

            if ($(ACCOUNT_PAGE_SELECTOR).length) {
                form = '#dwfrm_profile_changeschoolrole';
                submitCta = $(form).find('.btn-accountform-submit');
            }

            if($this.is('#selectAllGrades')) {
                $allGrades.prop('checked', true);
                $nopreference.prop('checked', false);
            } else if($this.hasClass('no-preference')) {
                $allGrades.prop('checked', false);
            } else {
                $nopreference.prop('checked', false);
            }

            clientSideValidation.enableDisbaleButton(form, submitCta);
        });
    },

    showHidePassword: function() {
        $('body').on('click', '.showhide-password', function() {
            $(this).find('svg').toggleClass("fa-eye fa-eye-slash");
            const input = $("#login-form-password");
            if (input.attr("type") === "password") {
                input.attr("type", "text");
            } else {
                input.attr("type", "password");
            }
        });
    },

    handleModalStepsClickEvent: function() {
        $('body').on('click', '.currentstep span.active', function() {
            var clickedStep = $(this).data('step'),
                stepBack =  $(MULTIPLESTEPS + ':not(".d-none")').find(BACK_STEP).data('stepback');
            if ( clickedStep > stepBack) {
                return; // don't do anything if clicked on current step
            } else if ( clickedStep === stepBack) { // if click on immediate back one
                $(MULTIPLESTEPS + '.step-' + (stepBack+1)).find(BACK_STEP).trigger('click'); // NOSONAR
            } else { // if click any other instead of immediate back one
                $(MULTIPLESTEPS + '.step-' + (clickedStep + 1)).find(BACK_STEP).trigger('click'); // NOSONAR
            }
        });
    },

    handleBackStep: function() {
        $('body').on('click', BACK_STEP, function() {
            const stepBackNo = $(this).data('stepback');
            const form = $(CREATE_ACCOUNT_SUBMIT_FORM_ID);
            $(MULTIPLESTEPS).addClass('d-none');
            $(MULTIPLESTEPS + '.step-' + stepBackNo).removeClass('d-none'); // NOSONAR

            $('.currentstep span').each(function() {
                if ($(this).data('step') > stepBackNo) {
                    $(this).removeClass('active').removeAttr('tabindex');
                } else if ($(this).data('step') === stepBackNo) {
                    $(this).removeAttr('tabindex');
                }
            });

            if (stepBackNo === 1) {
                if (formValidation.checkFormValid(form)) {
                    $(NEXT_STEP_VISIBLE).removeAttr(DISABLED_ATTR);
                }
                // Reset School Modal
                const schoolCodeInput = $('.multiplesteps.step-2 .is-invalid');
                $(schoolCodeInput).val('').removeClass('is-invalid').attr('aria-invalid', false);
                $(schoolCodeInput).siblings('.is-invalid').remove();
                $('.search-addnewschool').attr(DISABLED_ATTR, DISABLED_ATTR);
                $('.schoolcity-list-result').addClass('d-none');
            }
        });
    },

    handleNextStep: function() {
        $('body').on('click', '.next-step', function() {
            const $self = $(this);
            const stepNextNo = $self.data('stepnext');
            const form = $(CREATE_ACCOUNT_SUBMIT_FORM_ID);
            const loader = $(CREATE_ACCOUNT_MODAL_CONTENT);

            if (stepNextNo) {
                if ((stepNextNo === 2 || stepNextNo === 6) && !formValidation.checkFormValid(form)) {
                    return;
                }

                let isEmailValid = true;
                if (stepNextNo === 2) {
                    // Email Check then proceed or return
                    const emailCheckUrl = $self.data('href');
                    loader.spinner().start();
                    $.ajax({
                        url: emailCheckUrl,
                        data: {'email': $(form).find('.femail').val()},
                        async: false,
                        type: 'post',
                        success: function (data) {
                            const emailErrorMsg = $('.emailErrorMsg');
                            if (data.status === 'error') {
                                isEmailValid = false;
                                $(emailErrorMsg).html($self.data(data.accountStatus).replace('customernoplaceholder', data.customerNo)).removeClass('d-none');
                            } else {
                                $(emailErrorMsg).addClass('d-none');
                            }
                            loader.spinner().stop();
                        },
                        error: function() {
                            loader.spinner().stop();
                        }
                    });

                    if (!isEmailValid) {
                        return;
                    }

                    addNewSchool.init();
                }

                $(MULTIPLESTEPS).addClass('d-none');
                $(MULTIPLESTEPS + '.step-' + stepNextNo).removeClass('d-none'); // NOSONAR

                $('.step' + stepNextNo + '-indicator').addClass('active'); // NOSONAR

                $(document).on('change', '.pref-option input, #readPrivacyTerms', function() {
                    var keepDisable = true;
                    const $button = $(NEXT_STEP_VISIBLE);
                    if ($('input[name="dwfrm_profile_customer_language"]:checked').length &&
                        $('input[name="dwfrm_profile_customer_addtoemaillist"]:checked').length &&
                        $('#readPrivacyTerms:checked').length) {
                        keepDisable = false;
                    }
                    if (keepDisable) {
                        $button.attr(DISABLED_ATTR, DISABLED_ATTR);
                    } else {
                        $button.removeAttr(DISABLED_ATTR);
                    }
                });
            } else {
                // Submit Ajax
                const url = $(form).attr('action');
                loader.spinner().start();
                $.ajax({
                    url: url,
                    data: getCreateAccountFormData(),
                    type: 'post',
                    success: function (data) {
                        if (data.status === 'error') {
                            // Error TODO:Nitesh
                        } else {
                            $(CREATE_ACCOUNT_MODAL_CONTENT).empty().html(data.html);
                        }

                        loader.spinner().stop();
                    },
                    error: function(data) {
                        loader.spinner().stop();
                    }
                });
            }
        });
    },

    activationMailResend: function() {
        var resendEmailCounter = 0;
        $('body').on('click', '#accountActivationSubmitCta', function(e) {
            e.preventDefault();

            const loader = $(ACTIVATION_MODAL_CONTENT);
            loader.spinner().start();

            const url = $(this).data('href');
            $.ajax({
                url: url,
                type: 'post',
                data: $('#accountActivationSubmitForm').serialize(),
                success: function (data) {
                    resendEmailCounter = resendEmailCounter + 1;
                    $(ACTIVATION_MODAL_CONTENT).empty().html(data);
                    if (resendEmailCounter >= 3) {
                        $("#accountActivationSubmitCta").remove();
                    }
                    loader.spinner().stop();
                },
                error: function() {
                    loader.spinner().stop();
                }
            });
        });
    },

    requestPasswordMailResend: function() {
        var requestPasswordMailCounter = 0;
        $('body').on('click', RESET_PASSWORD_SEND_EMAIL_CTA_ID, function(e) {
            e.preventDefault();
            var modal = $('#requestPasswordResetModal');
            if ($(CREATE_ACCOUNT_MODAL_ID + ':visible').length) {
                modal = $(CREATE_ACCOUNT_MODAL_ID);
            } else if ($(SIGN_IN_MODAL_ID + ':visible').length) {
                modal = $(SIGN_IN_MODAL_ID);
            }

            const loader = $(modal).find(MODAL_CONTENT);
            loader.spinner().start();

            const url = $(this).data('href');
            $.ajax({
                url: url,
                type: 'post',
                data: {'customerNo': $('#passwordResetCustomerNo').val()},
                success: function (data) {
                    requestPasswordMailCounter = requestPasswordMailCounter + 1;
                    $(modal).find(MODAL_CONTENT).empty().html(data);
                    if (requestPasswordMailCounter >= 3) {
                        $(RESET_PASSWORD_SEND_EMAIL_CTA_ID).remove();
                    }
                    loader.spinner().stop();
                },
                error: function() {
                    loader.spinner().stop();
                }
            });
        });
    },

    setRequestPasswordCustomerNo: function() {
        // Set Customer Number for Email
        $(document).on('click', '.reset-password-radio', function() {
            const customerNumber = $(this).val();
            $('#passwordResetCustomerNo').val(customerNumber);
            $(RESET_PASSWORD_SEND_EMAIL_CTA_ID).removeAttr(DISABLED_ATTR);
        });
    },

    requestPasswordResetModalOpen: function() {
        $('body').on('click', '#password-reset', function() {
            $('body').trigger('requestPasswordResetModal:open');
        });
    },

    init: function() {
        populateCurrentYear();

        // Open Signin Modal
        $('body').on('click', '.signModal', function(e) {
            e.preventDefault();
            const url = $(this).data('href');
            $('body').trigger(SIGNIN_MODAL_OPEN, url);
        });

        $('body').on(SIGNIN_MODAL_OPEN, function (e, url, wishlistProductId, loginAfterTimeOut) {
            const closeDialog = $(MODAL_SHOW).length ? $('#' + $(MODAL_SHOW).attr('id')) : '';
            changeDialog(closeDialog, $(SIGN_IN_MODAL_ID));

            if (wishlistProductId && wishlistProductId !== 'undefined') {
                url = url + '?wishlistProductId=' + wishlistProductId; // NOSONAR
            }
            const loader = $(SIGN_IN_MODAL_ID + ' .modal-content');
            var loginShowData = {};
            if (window.location.href.indexOf(ACTIVATION_TOKEN) > 1) {
                loginShowData.activationToken = new URLSearchParams(window.location.search).get(ACTIVATION_TOKEN);
            }
            loader.spinner().start();
            $.ajax({
                url: url,
                type: 'get',
                data: loginShowData,
                success: function (data) {
                    $(SIGN_IN_MODAL_ID + ' .modal-body').empty().html(data);
                    if (loginAfterTimeOut) {
                        $('.session-timeout-signin-description').removeClass('d-none');
                    }

                    $(SIGN_IN_MODAL_ID + ' .close').on('click', function(e) {
                        e.preventDefault();
                        loginAfterTimeOut ? window.location.reload() : $(SIGN_IN_MODAL_ID).modal('hide');
                    });

                    loader.spinner().stop();
                    populateCurrentYear();
                    clientSideValidation.addValidation();

                    $('#loginForm').on(KEYUP_FOCUSOUT, "input", function() {
                        clientSideValidation.enableDisbaleButton('#loginForm', '#loginFormSubmitCta');
                    });

                    // Remember Me
                    const rememberMe = getCookie("rememberMe");
                    if (rememberMe) {
                        const emailElem = $('#login-form-email');
                        if (emailElem.length > 0) {
                            emailElem[0].value = rememberMe;
                        }
                        const rememberMeElem = $('#rememberMe');
                        if (rememberMeElem.length > 0) {
                            rememberMeElem[0].checked = true;
                        }
                    }
                },
                error: function() {
                    if (window.location.href.indexOf(ACTIVATION_TOKEN) > 1) {
                        window.location.href = getHomeUrl();
                    }
                    loader.spinner().stop();
                }
            });
        });

        $('body').on('click', '.activationModal', function(e) {
            e.preventDefault();
            const url = $(this).data('href');
            $('body').trigger('activationModal:open', url);
        });

        $('body').on('activationModal:open', function (e, url) {
            const closeDialog = $(MODAL_SHOW).length ? $('#' + $(MODAL_SHOW).attr('id')) : '';
            changeDialog(closeDialog, $('#activationModal'));

            $('#activationModal .modal-body').empty();

            var emailID = '';

            if ($(CREATE_ACCOUNT_MODAL_ID).is(':visible')) {
                emailID = $(CREATE_ACCOUNT_MODAL_ID + ' #email').val();
            } else {
                emailID = $(SIGN_IN_MODAL_ID + ' #login-form-email').val();
            }

            const loader = $(ACTIVATION_MODAL_CONTENT);
            loader.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                data: {email: emailID},
                success: function (data) {
                    $(ACTIVATION_MODAL_CONTENT).empty().html(data);

                    loader.spinner().stop();
                },
                error: function() {
                    loader.spinner().stop();
                }
            });
        });

        $('body').on('requestPasswordResetModal:open', function (e) {
            const newModal = $('#requestPasswordResetModal');
            changeDialog($(SIGN_IN_MODAL_ID), newModal);

            $(newModal).find(MODAL_BODY_SELECTOR).empty();

            const loader = $(newModal).find(MODAL_CONTENT);
            loader.spinner().start();

            $.ajax({
                url: $(newModal).data('href'),
                type: 'get',
                success: function (data) {
                    $(newModal).find(MODAL_CONTENT).empty().html(data);

                    loader.spinner().stop();
                    clientSideValidation.addValidation();

                    $('#requestPasswordResetForm').on(KEYUP_FOCUSOUT, "input", function() {
                        clientSideValidation.enableDisbaleButton('#requestPasswordResetForm', '#submitEmailButton');
                    });
                },
                error: function() {
                    loader.spinner().stop();
                }
            });
        });

        $('body').on('passwordResetModal:open', function (e) {
            const newModal = $('#passwordResetModal');
            const closeDialog = $(MODAL_SHOW).length ? $('#' + $(MODAL_SHOW).attr('id')) : '';
            changeDialog(closeDialog, newModal);

            $(newModal).find(MODAL_BODY_SELECTOR).empty();

            const loader = $(newModal).find(MODAL_CONTENT);
            loader.spinner().start();

            var loginShowData = {};
            if (window.location.href.indexOf(RESET_PASSWORD_TOKEN) > 1) {
                loginShowData.resetPasswordToken = new URLSearchParams(window.location.search).get(RESET_PASSWORD_TOKEN);
            }
            $.ajax({
                url: $(newModal).data('href'),
                type: 'get',
                data: loginShowData,
                success: function (data) {
                    $(newModal).find(MODAL_BODY_SELECTOR).html(data);

                    loader.spinner().stop();
                    clientSideValidation.addValidation();

                    const passwordresetsubmitform = $('#passwordResetSubmitForm');
                    const submitCta = $('#passwordResetSubmitCta');

                    $(passwordresetsubmitform).on(KEYUP_FOCUSOUT, "input", function() {
                        clientSideValidation.enableDisbaleButton(passwordresetsubmitform, submitCta);
                    });

                    $(passwordresetsubmitform).on(KEYUP_FOCUSOUT, "input.fpassword", function() {
                        var $elementForm = $(this).closest("form");
                        if (($elementForm.find(VALIDATE_CONFIRM_PASSWORD).val() !== "")) {
                            $elementForm.find(VALIDATE_CONFIRM_PASSWORD).trigger("keyup", {which: 50});
                        }
                        clientSideValidation.enableDisbaleButton(passwordresetsubmitform, submitCta);
                    });

                    $(submitCta).on('click', function(e) {
                        passwordResetFormSubmit(e, passwordresetsubmitform, loader);
                    });
                },
                error: function() {
                    window.location.href = getHomeUrl();
                }
            });
        });

        $('body').on('click', '.createAccount', function(e) {
            e.preventDefault();
            const createAccountShowUrl = $(this).data('href');
            const noNeedOfNewModal = $(this).hasClass('noNeedOfNewModal');
            $(CREATE_ACCOUNT_MODAL_ID + ' ' + MODAL_BODY_SELECTOR).empty(); // NOSONAR
            if (noNeedOfNewModal) {
                loadCreateAccountShowData(createAccountShowUrl, noNeedOfNewModal);
            } else {
                $('body').trigger('createAccountModal:open', createAccountShowUrl);
            }
        });

        $('body').on('createAccountModal:open', function (e, url) {
            if ($('.login-section.d-none').length) {
                $('.login-noneduattempt-section, .login-error').addClass('d-none');
            }
            changeDialog($(SIGN_IN_MODAL_ID), $(CREATE_ACCOUNT_MODAL_ID));
            loadCreateAccountShowData(url);
        });

        $('body').on('missingPrefModal:open', function (e) {
            $("#missingPrefModal").modal({keyboard: false, backdrop: 'static'}); // open the modal
            populateCurrentYear();
            $("#missingPrefModal #missingpref-accordion").html($('.missingPrefData').html());
            $(UPDATE_PRED_MODAL_GO_TO_PROFILE_ID).data('step', $('.get-gotostep').data('gotostep'));
            $('.missingPrefData').remove('');

            // Enable Disable Go to Profile CTA
            $('#consentPrivacyTerms').on('change', function () {
                const updatePredModalGoToProfile = $(UPDATE_PRED_MODAL_GO_TO_PROFILE_ID);
                if ($(this).is(':checked')) {
                    $(updatePredModalGoToProfile).removeAttr(DISABLED_ATTR);
                } else {
                    $(updatePredModalGoToProfile).attr(DISABLED_ATTR, DISABLED_ATTR);
                }
            });

            // Redirect to Accoung Page
            $(UPDATE_PRED_MODAL_GO_TO_PROFILE_ID).on('click', function() {
                const savedStep = $(this).data('step');
                let gotostep = '';
                if (savedStep) {
                    if (savedStep === 'PI') {
                        gotostep = 'profile';
                    } else if (savedStep === 'SR') {
                        gotostep = 'schoolrole';
                    } else {
                        gotostep = 'pref';
                    }
                }
                window.location.href = $(this).data('href') + (gotostep ? ('?step=' + gotostep) : '');
            });
        });

        // Show Login Screen
        $(document).on('click', '.backToLogin', function() {
            $('.login-noneduattempt-section, .login-error').addClass('d-none');
            $('.login-section').removeClass('d-none');
        });

        // Open the Missing Pref Modal except Account Page
        if ($('.showMissingPrefModal').val() === 'true' && !$(ACCOUNT_PAGE_SELECTOR).length) {
            $('body').trigger('missingPrefModal:open');
        }

        sessionTimeoutModal();

        if (localStorage.getItem('openSessionSignInModal')) {
            $('body').trigger(SIGNIN_MODAL_OPEN, [$("#sessionTimeoutModal").data('login'), null, true]);
            localStorage.removeItem('openSessionSignInModal');
        }
    },

    activationModalOpen: function() {
        if (window.location.href.indexOf(ACTIVATION_TOKEN) > 1) {
            $('.signModal:first').trigger('click');
    	}
    },

    resetPasswordModalOpen: function() {
        if (window.location.href.indexOf(RESET_PASSWORD_TOKEN) > 1) {
            $('body').trigger('passwordResetModal:open');
    	}
    },

    redirectToHome: function() {
        $('body').on('click', '.redirecttohome', function(e) {
            window.location.href = getHomeUrl();
        });
    },

    reinitiateWishlistIcon: function() {
        $('body').on('wishlist:reinitiateIcon', function (e, data) {
            var itemsWishlistJson = $('[name="itemsWishlistJson"]');
            if (itemsWishlistJson.length > 0) {
                try {
                    var productList = JSON.parse(itemsWishlistJson.val());
                    Object.keys(productList).forEach(function(productID) {
                        var wishlistIcon = $('.wishlist-icon.' + productID);
                        if (wishlistIcon.length && !wishlistIcon.hasClass('selected')) {
                            wishlistIcon.addClass('selected');
                            wishlistIcon.find('.wishlist-icon-regular').removeClass('d-flex').addClass('d-none');
                            wishlistIcon.find('.wishlist-icon-solid').removeClass('d-none').addClass('d-flex');
                        }
                    });
                } catch(e) { }
            }
        });

        $('body').ready(function() {
            $('body').trigger('wishlist:reinitiateIcon');
        });
    }
};
